module.exports = "App\\Entity\\Movie:\n    movie{1..10}:\n      name: '<sentence(4, true)>'\n      director: '<name()>'\n      year: '<numberBetween(1970, 2017)>'\n      picture: '<image(\"./public/images\", 500, 500, \"cats\", 0)>'"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/fixtures-movie-1.txt
// module id = 648
// module chunks = 111487850492888